import { asyncActionCreator } from '../../global/redux';
import * as constants from './constants';

// eslint-disable-next-line import/prefer-default-export
export const getMetricsByIdAction = asyncActionCreator(constants.GET_METRICS_BY_ID);
